function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { useState } from 'react';
import useUpdateEffect from '../useUpdateEffect';

// 判断对象是否为函数
function isFunction(obj) {
  return typeof obj === 'function';
}

function useStorageState(storage, key, defaultValue) {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
    return [isFunction(defaultValue) ? defaultValue() : defaultValue, function () {}];
  }

  var storageCopy = isFunction(storage) ? storage() : storage;

  var _useState = useState(function () {
    return getStoredValue();
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useUpdateEffect(function () {
    setState(getStoredValue());
  }, [key]); // 获取storage的值

  function getStoredValue() {
    var raw = storageCopy.getItem(key);

    if (raw) {
      try {
        return JSON.parse(raw);
      } catch (e) {}
    }

    if (isFunction(defaultValue)) {
      return defaultValue();
    }

    return defaultValue;
  } // 更新storage值


  function updateState(value) {
    if (typeof value === 'undefined') {
      storageCopy.removeItem(key);
      setState(undefined);
    } else if (isFunction(value)) {
      var _previousState = getStoredValue();

      var currentState = value(_previousState);
      storageCopy.setItem(key, JSON.stringify(currentState));
      setState(currentState);
    } else {
      storageCopy.setItem(key, JSON.stringify(value));
      setState(value);
    }
  }

  return [state, updateState];
}

export default useStorageState;